import React from "react";
import { VStack } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { H2Dashboard } from "components/text/headings";
import PieDialWithTotal from "../PieDialWithTotal";
import { gotoFilteredQuestionList } from "../AIDashboard/AIDashboard";
import { useNavigate } from "react-router-dom";
import SearchString from "search-string";
/**
 *
 * @param {Object[]} stageData [{id, value, color}]
 * @returns
 */
const PieByStage = ({ stageData }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const total = stageData.reduce((acc, item) => acc + item.value, 0);
  const navigate = useNavigate();

  const handleClick = (value) => {
    const searchString = SearchString.parse("");
    searchString.addEntry("stage", value?.id);

    const newParams = new URLSearchParams(searchParams);
    newParams.set("q", searchString.toString());
    gotoFilteredQuestionList(navigate, null, null, newParams);
  };

  return (
    <VStack
      spacing={4}
      // bg="gray.200"
      // borderRadius="lg"
      // boxShadow="lg"
      // borderColor="gray.200"
      w="100%"
      height="350px"
      p={6}
      display="flex"
      flexDirection="column"
      color="darkTeal"
    >
      <H2Dashboard>Stage</H2Dashboard>
      <PieDialWithTotal data={stageData} onClick={handleClick} totalLabel="Questions" />
    </VStack>
  );
};

export default PieByStage;
